import { useGlobal } from '@/utils/useGlobal';
import { Input as AntInput } from 'antd';
import css from './input.module.scss';

export default function Input({ children, ...rest }: any) {
    const { Search } = AntInput;
    const { useLang } = useGlobal();
    const { t } = useLang('shared');
    const classList = [css.efSearchInput];
    const props = {
        enterButton: <img src={`${process.env.NEXT_PUBLIC_CDN_URL || ''}/icons/search-light.svg`} alt={t('news.media.search')} />,
        ...rest,
    };
    if (rest.className) {
        classList.push(rest.className);
        props.className = classList.join(' ');
    }
    return <Search {...props} />;
}
